import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import Group from 'components/utils/Group'
import React, { PropsWithChildren, RefAttributes } from 'react'

interface Props extends PropsWithChildren, RefAttributes<HTMLDivElement> {
}

function _StepsTrack(props: Props) {
  const { ref, children, ...rest } = props
  return <HorizontalContainerWithFadedOverflow {...rest} ref={ref}>
    <Group direction="horizontal" gap={4} verticalAlign="center">
      {children}
    </Group>
  </HorizontalContainerWithFadedOverflow>
}

export default _StepsTrack
